import { Box, useTheme } from "@mui/material";
import GlobalConst from "../../Core/Utils/Constants/globals";
import { useDispatch } from "react-redux";
import {
  SetRightPanelPinned,
  SetLeftPanelPinned,
  SetLeftMounted,
  SetRightMounted,
} from "../../Redux/Reducers/redux-slice-layout";
import Resizer from "./resizer";
import { cacheService } from "../../Core/Api/services";
import { useEffect } from "react";
import "./side-layout-panel.css";
export interface SidePanelLayoutProps {
  panel: any;
  position: "left" | "right";
}

const SidePanelLayout: React.FC<SidePanelLayoutProps> = ({ panel, position }) => {
  const theme = useTheme();
  const width = position === "left" ? cacheService.GetLeftPanelWidth() : cacheService.GetRightPanelWidth();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(position === "left" ? SetLeftMounted(true) : SetRightMounted(true));

    return () => {
      dispatch(position === "left" ? SetLeftMounted(false) : SetRightMounted(false));
    };
  }, []);

  return (
    <Box
      className={`side-panel-wrapper ${position}-wrapper-resizable`}
      width={panel.open ? width ?? 0 : "0px"}
      onClick={() => {
        if (panel.pinned) dispatch(position === "left" ? SetLeftPanelPinned(false) : SetRightPanelPinned(false));
      }}
      sx={{
        cursor: panel.pinned ? "pointer" : "inherit",
        ...theme.helpers(theme).panelHighlights,
        paddingTop: "1px",
        position: "relative",
        borderRadius: panel.pinned ? 1 : 2,
        display: panel.open ? "inherit" : "none",
        "&:hover": {
          background: panel.pinned ? theme.palette.background.paper : theme.palette.background.default,
        },
      }}
    >
      <Resizer position={position} pinned={panel.pinned} />
      <Box
        sx={{
          display: panel.pinned ? "none" : "block",

          background: theme.palette.background.default,
          ...(theme.helpers(theme).scrollBar as any),
          ...(theme.helpers(theme).scrollableContainer as any),
        }}
        className={`side-panel-content-wrapper resizable ${
          position === "left" ? GlobalConst.LEFT_PANEL_CLASSNAME : GlobalConst.RIGHT_PANEL_CLASSNAME
        }`}
      ></Box>
    </Box>
  );
};

export default SidePanelLayout;
